"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkLabels = void 0;
var NetworkLabels;
(function (NetworkLabels) {
    NetworkLabels["xrpl"] = "xrp ledger";
    NetworkLabels["xevm"] = "xevm sidechain";
    NetworkLabels["xahau"] = "xahau";
})(NetworkLabels || (exports.NetworkLabels = NetworkLabels = {}));
//# sourceMappingURL=labels.js.map